import React from "react";
import Loader from "rsuite/Loader";
import styled from "styled-components";

import { StyledSpan } from "../../../common";

const Root = styled.div<Overlay.Root>`
	display: flex;

	justify-content: center;
	align-items: center;

	min-width: 18px;
	min-height: 18px;
	gap: 10px;

	${({ maxedSize }) =>
		maxedSize
			? `
        width: 100%;
        height: 100%;
      `
			: ""}

	background: ${({ dimmed, lightDimmed }) => {
		if (lightDimmed) return "rgba(255, 255, 255, 0.8)";
		if (dimmed) return "rgba(0, 0, 0, 0.5)";
		return "transparent";
	}};
`;

const Overlay: React.FC<Overlay.Props> = ({
	dimmed,
	lightDimmed,
	maxedSize,
	withText,
}) => {
	const text = "Loading...";

	return (
		<Root dimmed={dimmed} lightDimmed={lightDimmed} maxedSize={maxedSize}>
			<Loader />

			{withText && <StyledSpan>{text}</StyledSpan>}
		</Root>
	);
};

declare namespace Overlay {
	interface Props {
		dimmed: boolean;
		lightDimmed: boolean;
		maxedSize: boolean;
		withText: boolean;
	}

	interface Root {
		dimmed: boolean;
		lightDimmed: boolean;
		maxedSize: boolean;
	}
}

export default Overlay;
